<template>
  <div class="package-edit-form-container">
    <div class="site-list">
      <sp-tabs v-model="active_index" :tabs="tabs">
        <template #default="{ tabs }">
          <site-list :key="active_index" v-bind="tabs.length ? tabs[active_index].componentProps : {}" />
        </template>
      </sp-tabs>
    </div>
  </div>
</template>

<script>
import { data_sharing_mixin } from '@/views/fusion/investment/intelligence-create/mixins/data-sharing';

export default {
  components: {
    'app-filter': () => import('@/components/app-filter'),
    'app-table': () => import('@/components/app-table'),
    'sp-tabs': () => import('@/components/sp-tabs'),
    'site-list': () => import('./components/site-list/index.vue'),
  },
  mixins: [data_sharing_mixin],
  props: {
    /** 模块表单配置 */
    formFields: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      active_index: 0,
    };
  },
  computed: {
    tabs() {
      const { campaign_config } = this.local_sharing_data.getFormFields();
      const { delivery_form } = campaign_config.config;
      const { fusion__channel_code } = delivery_form.config;
      const { fusion__channel_codes } = fusion__channel_code.children;
      return fusion__channel_codes.value.map(advertiser => {
        return {
          label: advertiser.label,
          componentProps: {
            formFields: this.formFields,
            advertiserId: advertiser.advertiser_id,
            assignSelection: this.formFields.selection_config.list.filter(item => String(item.advertiser_id) === String(advertiser.advertiser_id)),
          },
        };
      });
    },
  },
  methods: {
    /**
     * 获取分配表单已选项
     * @returns {Promise<Object[]>}
     */
    async getAssignSelection() {
      const assign_selection = this.tabs.reduce((prev, curr) => {
        return prev.concat(curr.componentProps.assignSelection.map(assign => Object.assign(assign, { advertiser_id: curr.componentProps.advertiserId })));
      }, []);
      return Promise.resolve(assign_selection);
    },
  },
};
</script>

<style lang="scss" scoped>
.site-list {
  height: 500px;
}
</style>
